import * as React from 'react';
import { Icon, Sort } from 'rcd-cpp-ui/ui/icon';
import { cn } from '../../utils';
import './modalNav.scss';

interface Page {
  id?: string | number;
  label: string;
  Icon: any;
}

interface Props {
  selectedPage: Page | string | number;
  pages: Page[];
  prevPage: () => void;
  goToPage: (p: Page) => void;
}

const isSamePage = (p1: Page, p2: Page) => {
  const p1s = p1.id || p1.label;
  const p2s = p2.id || p2.label;
  return p1s == p2s;
};

export const ModalNav = ({
  selectedPage,
  pages,
  goToPage,
  prevPage
}: Props) => {
  const page = pages.filter(p => {
    if (typeof selectedPage != 'object') {
      return isSamePage(p, { id: selectedPage, label: selectedPage } as any);
    }
    return isSamePage(p, selectedPage);
  })[0];
  const hasPreviousPage = !isSamePage(page, pages[0]);
  return (
    <div className="modal-page-nav">
      <div>
        {pages.map(p => {
          const I = p.Icon;
          return (
            <div key={p.label} className={cn({ active: isSamePage(page, p) })}>
              <div>
                <span />
                <span
                  className="vpn-page"
                  onClick={() => {
                    goToPage(p);
                  }}
                >
                  {I && <I />}
                  <span>{p.label}</span>
                </span>
                <span />
              </div>
            </div>
          );
        })}
      </div>
      {!!prevPage && (
        <div>
          {hasPreviousPage && (
            <Icon onClick={prevPage}>
              <Sort />
            </Icon>
          )}
        </div>
      )}
    </div>
  );
};
